import ajax from "../utils/request";
const userApi = {
  /********************************用户管理*********************************** */
  // 添加用户
  addUser(params) {
    return ajax({
      url: "/user/add",
      type: "post",
      params: params,
    });
  },
  // 更新用户设备id
  resetDev(params) {
    return ajax({
      url: "/user/devID/reset",
      type: "post",
      params: params,
    });
  },
  // 用户导出
  exportUserList(params) {
    return ajax({
      url: "/export/userList",
      type: "get",
      params: params,
    });
  },
  // 请求用户管理模块禁言用户
  getUserBan(params) {
    return ajax({
      url: "/user/banned",
      type: "post",
      params: params,
    });
  },
  // 请求用户列表
  getUserList(params) {
    return ajax({
      url: "/user/list",
      type: "get",
      params: params,
    });
  },
  // 更新用户禁止上传状态
  resetForbid(params) {
    return ajax({
      url: "/user/forbid",
      type: "post",
      params: params,
    });
  },
  // 请求查看或生成验证码
  getViewCaptcha(params) {
    return ajax({
      url: "/extend/viewCaptcha",
      type: "get",
      params: params,
    });
  },
  // 请求用户观看视频详情列表
  getUserPlay(params) {
    return ajax({
      url: "/user/record/play",
      type: "get",
      params: params,
    });
  },
  // 请求用户管理模块禁止用户登陆
  getUserLock(params) {
    return ajax({
      url: "/user/lock",
      type: "post",
      params: params,
    });
  },
  // 编辑用户
  editUser(params) {
    return ajax({
      url: "/user/update",
      type: "post",
      params: params,
    });
  },
  //重置用户银行卡姓名
  restBankUserName(params) {
    return ajax({
      url: "/user/update",
      type: "post",
      params: params,
    },true);
  },
  // 理由列表
  getReasonList(params) {
    return ajax({
      url: "/rejectTemp/list",
      type: "get",
      params: params,
    });
  },
  // 新增理由
  addReasonList(params) {
    return ajax({
      url: "/rejectTemp/insert",
      type: "post",
      params: params,
    });
  },
  // 删除理由
  delReasonList(params) {
    return ajax({
      url: "/rejectTemp/del",
      type: "post",
      params: params,
    });
  },
  // 编辑理由
  editReasonList(params) {
    return ajax({
      url: "/rejectTemp/update",
      type: "post",
      params: params,
    });
  },

  // 用户加金币
  addUserGold(params) {
    return ajax({
      url: "/user/credit",
      type: "post",
      params: params,
    });
  },
  // 用户加AI脱衣免费次数
  addAiUndressFreeTimes(params) {
    return ajax({
      url: "/user/update/freeTimes",
      type: "post",
      params: params,
    });
  },
  // 用户加果币
  addUserFruitCoin(params) {
    return ajax({
      url: "/user/credit/fruitCoin",
      type: "post",
      params: params,
    });
  },
  // 用户VIP权益
  getUserVipInfo(params) {
    return ajax({
      url: "/user/vipInfo",
      type: "get",
      params: params,
    });
  },
  // 获取账号凭证
  getQrcode(params) {
    return ajax({
      url: "/user/qr_code",
      type: "post",
      params: params,
    });
  },
  // 查询会员卡
  queryVipCard(params) {
    return ajax({
      url: "/business/product/list",
      type: "get",
      params: params,
    });
  },
  // 私信
  sendMessage(params) {
    return ajax({
      url: "/user/chatMessage/send",
      type: "post",
      params: params,
    });
  },
  // 设置ai伴侣余额
  creditAiMateBalance(params) {
    return ajax({
      url: "/user/credit/aiMateBalance",
      type: "post",
      params: params,
    });
  },
  // 请求用户ai伴侣交易列表
  getUserAiMateTransList(params) {
    return ajax({
      url: "/aimate/trans_list",
      type: "get",
      params: params,
    });
  },
  /********************************用户私信列表*********************************** */
  // 请求用户私信列表
  getChatMessageList(params) {
    return ajax({
      url: "/user/chatMessage/list",
      type: "get",
      params: params,
    });
  },
  /********************************用户登陆日志*********************************** */
  // 请求用户登陆日志列表
  getLoginLog(params) {
    return ajax({
      url: "/user/login/list",
      type: "get",
      params: params,
    });
  },
  /********************************用户ip限制*********************************** */
  // 请求ip限制列表
  getIpBlock(params) {
    return ajax({
      url: "/ipblock/list",
      type: "get",
      params: params,
    });
  },
  // 修改IP限制
  editIpBlock(params) {
    return ajax({
      url: "/ipblock/edit",
      type: "post",
      params: params,
    });
  },
  // 删除IP限制
  delIpBlock(params) {
    return ajax({
      url: "/ipblock/del",
      type: "delete",
      params: params,
    });
  },
  // 添加IP限制
  addIpBlock(params) {
    return ajax({
      url: "/ipblock/add",
      type: "post",
      params: params,
    });
  },
  /********************************用户观看日志*********************************** */
  // 请求用户观看记录列表
  getWatchLog(params) {
    return ajax({
      url: "/user/play/list",
      type: "get",
      params: params,
    });
  },
  /********************************用户常见问题*********************************** */
  //请求用户常见问题列表

  //请求用户常见问题列表
  getUserQuestionList(params) {
    return ajax({
      url: "/user/faq/list",
      type: "get",
      params,
    });
  },
  //请求用户常见问题分类列表
  getClassificationList(params) {
    return ajax({
      url: "/user/faq/cate/list ",
      type: "get",
      params,
    });
  },
  // 新增问题
  AddQuestion(params) {
    return ajax({
      url: "/user/faq/add",
      type: "post",
      params,
    });
  },
  // 编辑问题
  EditQuestion(params) {
    return ajax({
      url: "/user/faq/update",
      type: "post",
      params,
    });
  },
  // 删除问题
  DeleteQuestion(params) {
    return ajax({
      url: "/user/faq/del",
      type: "delete",
      params,
    });
  },
  /********************************用户举报列表*********************************** */
  // 请求用户举报列表
  getUserReport(params) {
    return ajax({
      url: "/user/report/list",
      type: "get",
      params: params,
    });
  },
  // 请求用户举报列表
  setRept(params) {
    return ajax({
      url: "/user/report/setStatus",
      type: "post",
      params: params,
    });
  },
  // 请求举报分类列表
  getReportTypes(params) {
    return ajax({
      url: "/user/report/types/list",
      type: "get",
      params: params,
    });
  },
  /********************************黑名单列表*********************************** */
  //请求黑名单列表
  getBlackList(params) {
    return ajax({
      url: "/blacklist/list",
      type: "get",
      params,
    });
  },
  // 移除黑名单
  removeBlackList(params) {
    return ajax({
      url: "/blacklist/delete",
      type: "delete",
      params: params,
    });
  },
  // 添加黑名单
  addBlackList(params) {
    return ajax({
      url: "/blacklist/add",
      type: "post",
      params: params,
    });
  },

  /********************************用户推荐列表*********************************** */
  // 请求用户推荐列表
  getRecommendationList(params) {
    return ajax({
      url: "/user/reco/list",
      type: "get",
      params: params,
    });
  },
  // 用户推荐修改
  updateRecommendation(params) {
    return ajax({
      url: "/user/reco/modify",
      type: "post",
      params: params,
    });
  },
  // 用户推荐新增
  addRecommendation(params) {
    return ajax({
      url: "/user/reco/add",
      type: "post",
      params: params,
    });
  },
  // 用户推荐删除
  delRecommendation(params) {
    return ajax({
      url: "/user/reco/del",
      type: "post",
      params: params,
    });
  },

  /**********************用户反馈列表******************** */
  // 请求用户反馈列表
  getFeedbackList(params) {
    return ajax({
      url: "/user/feedback/list",
      type: "get",
      params: params,
    });
  },
  //用户反馈修改
  updateFeedback(params) {
    return ajax({
      url: "/user/feedback/update",
      type: "post",
      params: params,
    });
  },
  //用户反馈删除
  delFeedback(params) {
    return ajax({
      url: "/user/feedback/del",
      type: "delete",
      params: params,
    });
  },
  //查询游戏余额
  queryBalance(params) {
    return ajax({
      url: "/game/wali/balance/get",
      type: "post",
      params: params,
    });
  },
  //回收游戏余额
  recycleGameBal(params) {
    return ajax({
      url: "/game/wali/transfer",
      type: "post",
      params: params,
    });
  },
  //回收金币
  recycleIncome(params) {
    return ajax({
      url: "/user/credit/gold",
      type: "post",
      params: params,
    });
  },

  /**********************用户操作日志列表******************** */
  // 请求用户日志列表
  getUserLogList(params) {
    return ajax({
      url: "/operation/log/list",
      type: "get",
      params: params,
    });
  },

  // 查询所有工作室用户
  queryStudioList(params) {
    return ajax({
      url: "/user/madou/list ",
      type: "post",
      params: params,
    });
  },
  /********************************用户资源配置*********************************** */
  // 请求用户资源配置列表
  getResource(params) {
    return ajax({
      url: "/user/resource/list",
      type: "get",
      params: params,
    });
  },
  // 删除用户资源配置
  delResource(params) {
    return ajax({
      url: "/user/resource/del",
      type: "post",
      params: params,
    });
  },
  // 新增用户资源配置
  addResource(params) {
    return ajax({
      url: "/user/resource/add",
      type: "post",
      params: params,
    });
  },
  // 编辑用户资源配置
  updResource(params) {
    return ajax({
      url: "/user/resource/update",
      type: "post",
      params: params,
    });
  },
  // 设置用户是否打广告
  setUserAdv(params) {
    return ajax({
      url: "/user/advertiser",
      type: "post",
      params: params,
    });
  },

};

export default userApi;
